/**
 * Events constants for player
 * @typedef {{
 * play: string,
 * waiting: string,
 * positionChanged: string,
 * mediaEnded: string,
 * buffer: string,
 * seeked: string,
 * error: string
 * }} StreamEvents
 */
const streamEvents = {
  buffer: 'buffer',
  positionChanged: 'positionChanged',
  waiting: 'waiting',
  play: 'play',
  error: 'error',
  mediaEnded: 'mediaEnded',
  seeked: 'seeked',
  meta: 'meta',
  playerSelected: 'playerSelected',
};

export default streamEvents;
